import api from '../api/axiosInstance';
// src/api/authService.js
//@param {Object} credentials - { email: string, password: string }
//@returns {Promise<Object>} - { token, roles, email }
export const registerEmpleadoService = async (credentials) => {
    try {
        const response = await api.post('/propietario/registrar-empleado', credentials);
        return { success: true, data: response.data };
    } catch (error) {
        const mensaje = error.response?.data?.mensaje || 'Error desconocido al registrar empleado.';
        return { success: false, mensaje };
    }
};
